const CITY_ACTION_TYPES = Object.freeze({
  FETCH_DATA_CITIES: 'FETCH_DATA_CITIES',
});

export default CITY_ACTION_TYPES;
